import { MateCard } from "@/types/mateTypes";
import { MateCardItem } from "./MateCardItem";

interface MatesGridProps {
  mates: MateCard[];
}

export function MatesGrid({ mates }: MatesGridProps) {
  return (
    <div className="space-y-2 mb-6">
      {mates.map((mate) => (
        <MateCardItem key={mate.mateship_id} mate={mate} />
      ))}
    </div>
  );
}
